import { useGetServerTime } from '@engoo/react-server-time';
import LessonBookingRole from 'app/constants/LessonBookingRole';
import { BookingState, BookingType } from 'app/models/rtc/booking/constants';
import { createPollingIntervals } from 'app/services/rtc/bookings/behavior/lesson';
import { poll } from 'app/services/rtc/bookings/behavior/polling';
import { CancelToken } from 'app/utils/cancelToken';
import { createElement, Fragment, FunctionComponent, useEffect } from 'react';

interface IBookingPollingProps {
  bookingState?: BookingState;
  fetch: (cancelToken: CancelToken) => Promise<unknown>;
}

const BookingPolling: FunctionComponent<IBookingPollingProps> = ({ bookingState, children, fetch }) => {
  const getServerTime = useGetServerTime();

  // Refresh polling any time the booking state changes.
  useEffect(() => {
    if (bookingState?.bookingType === BookingType.Lesson && bookingState.lessonRole !== LessonBookingRole.Other) {
      const { lessonRole, time: { start } } = bookingState;
      const pollingIntervals = createPollingIntervals(new Date(start), lessonRole);
      return poll(fetch, getServerTime, pollingIntervals, { distributeLoad: true });
    }
  }, [bookingState, getServerTime, fetch]);

  return createElement(Fragment, {}, children);
};

export default BookingPolling;
